import { Backdrop } from '@mui/material';
import { useNavigation } from 'react-router';
import styles from './styles';

const Loader = () => {
  const navigation = useNavigation();
  const isNavigating = Boolean(navigation.location);
  const shouldShowLoader = isNavigating;

  return (
    shouldShowLoader && (
      <Backdrop sx={styles.backdrop} open={shouldShowLoader} />
    )
  );
};

export default Loader;
